module.exports = __webpack_public_path__ + "media/images/plans/online-wedding-spacemarket-logo-c25c3c7a4b68ccacf4367019b484d18c.png";